// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2HZia","list":"BalanceDue_list__2rF8p","listRow":"BalanceDue_listRow__3-y-m","total":"BalanceDue_total__2LUSi"};